var map = {
	"./auditory-card1.png": 1254,
	"./auditory-card2.png": 2461,
	"./auditory-card3.png": 1332,
	"./auditory-counseling-desktop.png": 7953,
	"./auditory-counseling-mobile.png": 3963,
	"./auditory-feature-mobile-01.png": 8686,
	"./auditory-feature-mobile-02.png": 4437,
	"./auditory-feature-mobile-03.png": 8524,
	"./auditory-feature-mobile-04.png": 8419,
	"./benefits-desktop.png": 1870,
	"./benefits-mobile.png": 9938,
	"./day-schedule.png": 3449,
	"./feat-reports-desktop.png": 7168,
	"./feat-reports-mobile.png": 6588,
	"./innovation-product.png": 2426,
	"./patient-galery-mobile.png": 908,
	"./patient-hist-cli-mobile.png": 329,
	"./patient-odontogram-mobile.png": 114,
	"./patient-payments-mobile.png": 6129,
	"./patient-product.png": 5456,
	"./patient-recipes-desktop.png": 2135,
	"./patient-recipes-mobile.png": 8510,
	"./patient-schedule-mobile.png": 5123,
	"./prof-schedule.png": 1044,
	"./purposes-desktop.png": 175,
	"./purposes-mobile.png": 441,
	"./schedule-product.png": 4660,
	"./shield-card1.png": 1294,
	"./shield-card2.png": 3717,
	"./shield-card3.png": 6204,
	"./shield.png": 9614,
	"./statistics-benefits-product.webp": 7285,
	"./statistics-budgets-product.webp": 4673,
	"./statistics-experience.png": 391,
	"./statistics-finances-product.webp": 7750,
	"./statistics-metrics-product.webp": 7894,
	"./statistics-product.png": 8142,
	"./weekly-schedule.png": 8660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6025;